import { Button } from '@mantine/core';
import React from 'react';

import { PartnerTypeSelection } from '../components/PartnerTypeSelection';
import { StepsFooter } from '../components/StepsFooter';
import { StepsHeader } from '../components/StepsHeader';
import { useInvitePartnerWizard } from '../hooks';

export function NewPartnerType() {
  const { contextData, onPrev, isNextDisabled } = useInvitePartnerWizard();

  return (
    <>
      <StepsHeader
        title="What is your relationship?"
        description="The partner is:"
      />

      <PartnerTypeSelection />

      <StepsFooter>
        <Button variant="default" onClick={onPrev}>
          Back
        </Button>

        <Button
          disabled={isNextDisabled}
          onClick={contextData.onInviteNewPartner}
        >
          Invite
        </Button>
      </StepsFooter>
    </>
  );
}
